import * as React from 'react'
import clsx from 'clsx'

import type { CustomListProps, OptionItem } from '@wartek-id/select'
import { CustomSelect } from '@wartek-id/select'
import { Text } from '@wartek-id/text'

import { MONTHS } from 'app/KinerjaShared/components/DatePicker/constants'
import styles from 'app/KinerjaShared/components/DatePicker/DatePicker.module.css'

import type { CalendarState } from '@react-stately/calendar'

function CustomList(props: CustomListProps) {
  const { name: month } = props.item as OptionItem

  return (
    <div
      date-testid="option-month"
      className={clsx([
        props.active && 'calendarDropdownActiveItem',
        props.disabled && styles.calendarDropdownDisabledItem,
      ])}
    >
      <Text color={props.disabled ? 'subdued' : 'default'}>{month}</Text>
    </div>
  )
}

function CustomDisplayValue(props: Pick<CustomListProps, 'item'>) {
  const { name: month } = props.item as OptionItem

  return <span data-testid="selected-month">{month}</span>
}

export function CalendarMonthDropdown({ state }: { state: CalendarState }) {
  const onChangeMonth = (value: OptionItem | string) => {
    const month = typeof value === 'string' ? value : value.name
    const monthInNumber = MONTHS.findIndex((m) => m === month) + 1

    const date = state.focusedDate.set({ month: monthInNumber })
    state.setFocusedDate(date)
  }

  const activeMonthValue = {
    name: MONTHS[state.focusedDate.month - 1],
  }

  const dateValidation = {
    min: state.minValue?.toString(),
    max: state.maxValue?.toString(),
  }

  // get months disabled state based on min and max date validation
  const mappedMonths = MONTHS.map((month, index) => {
    const date = state.focusedDate.set({ month: index + 1 }).toString()

    const isValidBasedOnMinDate = dateValidation?.min
      ? date >= dateValidation?.min
      : true

    const isValidBasedOnMaxDate = dateValidation?.max
      ? date <= dateValidation?.max
      : true

    const isDisabled = !(isValidBasedOnMinDate && isValidBasedOnMaxDate)

    return {
      name: month,
      disabled: isDisabled,
    } as OptionItem
  })

  return (
    <CustomSelect
      className={styles.dropdownCalendar}
      options={mappedMonths}
      customList={CustomList}
      customDisplayValue={CustomDisplayValue}
      value={activeMonthValue}
      onChange={onChangeMonth}
    />
  )
}
